import _Vue from 'vue';

// Import directives
import mask from '~/directives/mask';

// Import plugins
import AlertsPlugin from '~/plugins/alerts/install';
import DialogPlugin from './plugins/dialog/install';

// Export default plugin install function
export default {
  install(Vue: typeof _Vue) {
    Vue.directive('mask', mask);

    // Install plugins
    AlertsPlugin(Vue);
    DialogPlugin(Vue);
  },
};
